import * as React from 'react';

import { useLoginValue } from 'context';

import { LoginPhoneNumberForm } from './phone-number';
import { LoginPinForm } from './pin';

const LoginOTPForm = () => {
  const { step } = useLoginValue();

  if (step === 2) {
    return <LoginPinForm />;
  }

  return <LoginPhoneNumberForm />;
};

export { LoginOTPForm };
